var symphony = symphony || {};

;
(function () {

	var $parent = $(window);
	var firstSlide = true;

	symphony.heroSliderResizeCount = 0;
	symphony.heroSlider = function ($elm) {

		$parent = $elm || $(window);

		function resizeImages() {
			symphony.heroSliderResizeCount++;
			setTimeout(function () {
				$('.heroContainer .hero').each(function (idx, heroElm) {
					var hero = $(heroElm);
					if (hero.parents('.alloy-contentContainer').length === 0) {
						var heroImage = hero.find('img.heroImage').eq(0);
						if (heroImage.hasClass('lazyloaded') && !heroImage.hasClass('loaded')) {
							var isIframe = typeof heroImage[0] != "undefined" && ((typeof heroImage[0].tagName != "undefined" && heroImage[0].tagName.toLowerCase() == "iframe") || (typeof heroImage[0].id != "undefined" && heroImage[0].id.indexOf("youtube") > -1));
							if (!isIframe) {
								if (heroImage.outerHeight() < hero.outerHeight()) {
									heroImage.addClass('inverted');
								}
							}
							heroImage.addClass('loaded');
						}
					}
				});
			}, 100);

			// try to resize images for a whole minute before giving up
			if ($('.heroContainer .hero img.heroImage:not(.loaded)').length > 0 && symphony.heroSliderResizeCount < 300) {
				setTimeout(function () {
					resizeImages();
				}, 200);
			}
		}

		$('.heroContainer').each(function (idx, heroContainerElm) {

			var deviceWidth = $parent.width();
			var heroContainer = $(heroContainerElm);
			var heroText = heroContainer.find('.heroText');
			var heroSlider = heroContainer.find('.heroSlider:not(.slick-initialized)').eq(0);
			var heroHeight = heroContainer.outerHeight();

			if (typeof isLocal == 'undefined') {
				isLocal = false;
			}

			function dealWithScheduledSlides() {
				var scheduledHero = heroSlider.find('.hero.not-ready')[0];
				if (scheduledHero) {
					$(scheduledHero).removeClass('not-ready');
					if (new Date() >= new Date(scheduledHero.getAttribute('data-start')) && new Date() < new Date(scheduledHero.getAttribute('data-end'))) {
						$(scheduledHero).show();
					} else {
						$(scheduledHero).remove();
					}
					dealWithScheduledSlides();
				}
			}

			dealWithScheduledSlides();

			if (heroSlider && heroSlider.length > 0) {
				heroSlider.slick({
					//lazyLoad: 'ondemand',
					slide: '.hero',
					fade: true,
					mobileFirst: true,
					swipeToSlide: true,
					dots: true,
					autoplay: true,
					autoplaySpeed: 5000
				});
			}

			function calculateScroll() {
				var scroll = $parent.scrollTop();
				var opacity = 1 - (scroll / (heroHeight / 2));
				var percentageLeft = scroll / heroHeight * 100;
				heroText.css('opacity', opacity).css('margin-top', -percentageLeft);

			}


			// We are loading <img src> into each slide, then using css object-fit to fill the space.
			// Doing this enables us to lazy load the slider images, saving on load times
			// IE does not support this method, so here is a fallback to set the <img src> URl as the slide BG image
			if (!Modernizr.objectfit) {
				heroContainer.find('.hero').each(function () {
					var $container = $(this),
						imgUrl = $container.find('img').data('lazy');
					if (imgUrl) {
						$container
							.css('backgroundImage', 'url(' + imgUrl + ')')
							.addClass('compat-object-fit');

						$container.find('img').addClass('u-hidden');
					}
				});
			}

			if (firstSlide && deviceWidth > 768 && heroContainer.length > 0) {

				var stickyDetect = new Waypoint.Inview({
					element: heroContainer[0],
					enter: function () {
						$parent.on('scroll', _.throttle(calculateScroll, 10));
					},
					exit: function () {
						$parent.on('scroll', _.throttle(calculateScroll, 10));
					},
					exited: function () {
						heroText.css({
							y: '-50%'
						});
						//$parent.unbind('scroll');
					}
				});
			}

			if (firstSlide && isLocal && pageType === 'home' && typeof conductorSlides != "undefined" && conductorSlides.length >= 1) {
				for (var i = 0; i < conductorSlides.length; i++) {
					if (conductorSlides[i].useSchedule && !(new Date() >= new Date(conductorSlides[i].startDate) && new Date() < new Date(conductorSlides[i].endDate))) {
						conductorSlides.splice(i, 1);
						i = i - 1;
					}
				}

				var $slideHolder = $('<div />');
				$slideHolder.empty().append(symphony.templates.localSlide({
					slide: conductorSlides,
					siteUrlAlias: siteUrlAlias
				}));
				if (heroSlider.find('.hero').length == 0) {
					heroSlider.slick('destroy');
					heroSlider.html($slideHolder.html());
					conductorSlides = [];
					symphony.heroSlider();
				} else {
					var firstCond = $.grep(conductorSlides, function (x) {
						return !x.afterFirstLocal;
					});
					var secondCond = $.grep(conductorSlides, function (x) {
						return x.afterFirstLocal;
					});
					if (secondCond.length == 0) {
						var $slideHolder = $('<div />');
						$slideHolder.empty().append(symphony.templates.localSlide({
							slide: conductorSlides,
							siteUrlAlias: siteUrlAlias
						}));
						heroSlider.slick('slickAdd', $slideHolder.html(), 0, true);
					} else {
						var $slideHolder = $('<div />');
						$slideHolder.empty().append(symphony.templates.localSlide({
							slide: secondCond,
							siteUrlAlias: siteUrlAlias
						}));
						heroSlider.slick('slickAdd', $slideHolder.html(), 0, false);

						if (firstCond.length > 0) {
							$slideHolder = $('<div />');
							$slideHolder.empty().append(symphony.templates.localSlide({
								slide: firstCond,
								siteUrlAlias: siteUrlAlias
							}));
							heroSlider.slick('slickAdd', $slideHolder.html(), 0, true);
						}
					}
				}
				conductorSlidesUsed = true;
			}

			firstSlide = false;
		});

		resizeImages();

	};

})();
